import React from "react";
import { Box, Typography, styled } from "@mui/material";

const HistoryTab = ({ item }) => {
  const dateObj = new Date(item?.ReferralDate);
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("default", { month: "short" });

  return (
    <StyledContainer>
      {/* Date Box */}
      <StyledDateContainer>
        <StyledDateText>{day}</StyledDateText>
        <StyledMonthText>{month}</StyledMonthText>
      </StyledDateContainer>

      {/* Info Section */}
      <StyledNameContainer>
        <StyledOptionText>Points Received</StyledOptionText>
        <StyledNameText>
          {item?.ReferralName?.length > 20
            ? item.ReferralName.substring(0, 15) + "..."
            : item?.ReferralName || ""}
        </StyledNameText>
      </StyledNameContainer>

      {/* Amount Display */}
      <StyledAmountContainer>
        <StyledAmountText isHigh={item?.ReferralAmount > 0}>
          {item?.ReferralAmount}
        </StyledAmountText>
      </StyledAmountContainer>
    </StyledContainer>
  );
};

// Styled Components with Responsive Design
const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "rgba(243, 247, 243, 1)",
  border: "1px solid rgba(127, 168, 135, 0.2)",
  borderRadius: "12px",
  padding: "12px 20px",
  marginBottom: "15px",
  width: "100%",
  maxWidth: "600px",
  boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.05)",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: "3px 6px 12px rgba(0, 0, 0, 0.1)",
  },
  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap",
    padding: "10px 15px",
    maxWidth: "95%",
  },
}));

const StyledDateContainer = styled(Box)(({ theme }) => ({
  height: "56px",
  width: "56px",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "white",
  boxShadow: "2px 3px 6px rgba(0, 0, 0, 0.1)",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
  [theme.breakpoints.down("sm")]: {
    height: "50px",
    width: "50px",
  },
}));

const StyledDateText = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "bold",
  fontFamily: "LeagueSpartan-SemiBold",
  color: "rgba(35, 64, 0, 1)",
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

const StyledMonthText = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontFamily: "LeagueSpartan-Regular",
  color: "#808080",
  [theme.breakpoints.down("sm")]: {
    fontSize: "11px",
  },
}));

const StyledNameContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: "15px",
  flex: 1,
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
    marginLeft: 0,
    width: "100%",
  },
}));

const StyledOptionText = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontFamily: "LeagueSpartan-Medium",
  fontWeight: "bold",
  color: "rgba(35, 64, 0, 1)",
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}));

const StyledNameText = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontFamily: "LeagueSpartan-Regular",
  color: "rgba(127, 168, 135, 1)",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

const StyledAmountContainer = styled(Box)(({ theme }) => ({
  marginRight: "10px",
  [theme.breakpoints.down("md")]: {
    marginRight: "0",
    marginTop: "5px",
  },
}));

const StyledAmountText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isHigh",
})(({ theme, isHigh }) => ({
  fontSize: "22px",
  fontWeight: "bold",
  fontFamily: "LeagueSpartan-Regular",
  color: isHigh ? "rgba(255, 89, 0, 1)" : "#808080",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export default HistoryTab;
